// ACTION TYPES //
export const EMAIL_SENT = 'lead/email-sent'
export const SUBMIT_DETAILS = 'lead/submit-details'

export const POST_DETAILS = 'lead/post-details'
export const POST_DETAILS_FINISHED = 'lead/post-details-finished'
export const POST_DETAILS_FAILED = 'lead/post-details-failed'

export const SEND_VERIFICATION_CODE = 'lead/send-verification-code'
export const SEND_VERIFICATION_CODE_FINISHED = 'lead/send-verification-code-finished'
export const SEND_VERIFICATION_CODE_FAILED = 'lead/send-verification-code-failed'

export const VERIFY_CODE = 'lead/verify-code'
export const VERIFY_CODE_FINISHED = 'lead/verify-code-finished'
export const VERIFY_CODE_FAILED = 'lead/verify-code-failed'

export const LOAD_PARTIAL_REPORT = 'lead/load-partial-report'
export const LOAD_PARTIAL_REPORT_FINISHED = 'lead/load-partial-report-finished'
export const LOAD_PARTIAL_REPORT_FAILED = 'lead/load-partial-report-failed'

export const LOAD_REPORT_THRESHOLD = 'lead/load-report-threshold'
export const LOAD_REPORT_THRESHOLD_FINISHED = 'lead/load-report-threshold-finished'
export const LOAD_REPORT_THRESHOLD_FAILED = 'lead/load-report-threshold-failed'

// ACTIONS //
export const emailSent = () => ({
  type: EMAIL_SENT
})

export const submitDetails = (payload) => ({
  type: SUBMIT_DETAILS,
  payload
})

export const postDetails = () => ({
  type: POST_DETAILS
})

export const postDetailsFinished = (payload) => ({
  type: POST_DETAILS_FINISHED,
  payload
})

export const postDetailsFailed = (code) => ({
  type: POST_DETAILS_FAILED,
  payload: { code }
})

export const sendVerificationCode = (isResend = false, mobileNumber = null) => ({
  type: SEND_VERIFICATION_CODE,
  payload: {
    isResend,
    mobileNumber
  }
})

export const sendVerificationCodeFinished = (payload) => ({
  type: SEND_VERIFICATION_CODE_FINISHED,
  payload
})

export const sendVerificationCodeFailed = (code) => ({
  type: SEND_VERIFICATION_CODE_FAILED,
  payload: { code }
})

export const verifyCode = (payload) => ({
  type: VERIFY_CODE,
  payload
})

export const verifyCodeFinished = (payload) => ({
  type: VERIFY_CODE_FINISHED,
  payload
})

export const verifyCodeFailed = (payload) => ({
  type: VERIFY_CODE_FAILED,
  payload
})

export const loadPartialReport = (payload) => ({
  type: LOAD_PARTIAL_REPORT,
  payload
})

export const loadPartialReportFinished = (payload) => ({
  type: LOAD_PARTIAL_REPORT_FINISHED,
  payload
})

export const loadPartialReportFailed = (payload) => ({
  type: LOAD_PARTIAL_REPORT_FAILED,
  payload
})

export const loadReportThreshold = () => ({
  type: LOAD_REPORT_THRESHOLD
})

export const loadReportThresholdFinished = (payload) => ({
  type: LOAD_REPORT_THRESHOLD_FINISHED,
  payload
})

export const loadReportThresholdFailed = (payload) => ({
  type: LOAD_REPORT_THRESHOLD_FAILED,
  payload
})
